import { render, staticRenderFns } from "./officeOrderWxDetail.vue?vue&type=template&id=18dbed81&scoped=true&"
import script from "./officeOrderWxDetail.vue?vue&type=script&lang=js&"
export * from "./officeOrderWxDetail.vue?vue&type=script&lang=js&"
import style0 from "./officeOrderWxDetail.vue?vue&type=style&index=0&id=18dbed81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbed81",
  null
  
)

export default component.exports